<template>
  <div class="map-popup-item">
    <div
      class="product-image"
      :style="{
        backgroundImage: `url(${require(`../../assets/images/home/${this.image}.jpg`)})`
      }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "map-popup-item",
  props: { image: String }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";

.map-popup-item {
  height: 2.5rem;
  width: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 15px -5px #000000;

  .product-image {
    background-size: cover;
    background-position: center;
    height: 100%;
    width: 100%;
    border-radius: 50%;
  }
}
</style>
